import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/ArticlePage";
import FullGuide from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuyspreadsheet-guide",
    element: <FullGuide />,
  },
  {
    path: "/what-is-allchinabuyspreadsheet",
    element: <ArticlePage slug="what-is-allchinabuyspreadsheet" />,
  },
  {
    path: "/how-to-use-allchinabuyspreadsheet",
    element: <ArticlePage slug="how-to-use-allchinabuyspreadsheet" />,
  },
  {
    path: "/winning-products-china",
    element: <ArticlePage slug="winning-products-china" />,
  },
  {
    path: "/tiktok-viral-products",
    element: <ArticlePage slug="tiktok-viral-products" />,
  },
  {
    path: "/high-margin-dropshipping-items",
    element: <ArticlePage slug="high-margin-dropshipping-items" />,
  },
  {
    path: "/alibaba-vs-spreadsheet",
    element: <ArticlePage slug="alibaba-vs-spreadsheet" />,
  },
  {
    path: "/best-sourcing-platforms",
    element: <ArticlePage slug="best-sourcing-platforms" />,
  },
  {
    path: "/how-to-start-dropshipping",
    element: <ArticlePage slug="how-to-start-dropshipping" />,
  },
  {
    path: "/product-research-guide",
    element: <ArticlePage slug="product-research-guide" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;